import {PropsWithChildren} from 'react';

import {FilterSourceProvider} from 'filters';
import {useGlobalFilterSource} from 'features/GlobalFilterProvider/hooks/useGlobalFilterSource';
import {GlobalFilterDialogProvider} from 'features/GlobalFilterProvider/GlobalFilterDialogProvider';
import {GlobalFilterTopbarProvider} from 'features/GlobalFilterProvider/GlobalFilterTopbarProvider';
import {FilterActionsProvider} from 'filters/contexts/FilterActionsProvider';
import {useGlobalStoredFilters} from 'features/GlobalFilterProvider/hooks/useGlobalStoredFilters';
import {useGlobalStoredFiltersActions} from 'features/GlobalFilterProvider/hooks/useGlobalStoredFiltersActions';
import {useGlobalFilterApply} from 'features/GlobalFilterProvider/hooks/useGlobalFilterApply';

export const GlobalFilterProvider = ({children}: PropsWithChildren) => {
  return (
    <FilterSourceProvider useFilter={useGlobalFilterSource}>
      <FilterActionsProvider
        useStoredFilters={useGlobalStoredFilters}
        useStoredFiltersActions={useGlobalStoredFiltersActions}
        useApplyFilter={useGlobalFilterApply}
      >
        <GlobalFilterDialogProvider>
          <GlobalFilterTopbarProvider>{children}</GlobalFilterTopbarProvider>
        </GlobalFilterDialogProvider>
      </FilterActionsProvider>
    </FilterSourceProvider>
  );
};
